import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import MainLayout from "../../components/Layout/MainLayout";
import NotFound from "../../pages/NotFound";

// Lazy load components for better performance
const Dashboard = lazy(() => import("../features/Dashboard"));
const Surveys = lazy(() => import("../features/Surveys"));
const Visits = lazy(() => import("../features/Visits"));
const ConductSurvey = lazy(() => import("../features/survey/conductSurvey"));
const BuildingsSurveys = lazy(() => import("../features/survey/buildingsSurveys"));
const Areas = lazy(() => import("../features/survey/Areas"));
const Equipments = lazy(() => import("../features/survey/Equipments"));
const Attendance = lazy(() => import("../features/Attendance"));
const ExportSurvey = lazy(() => import("../features/survey/export"));
const FireExtinguisherEquipments = lazy(() => import("../features/survey/fireExtEquipments"));

// Reusable route wrapper component
const RouteWrapper = ({ active, children }) => (
  <MainLayout active={active}>
    <Suspense fallback={<div>Loading...</div>}>
      {children}
    </Suspense>
  </MainLayout>
);

// Route configuration objects
const dashboardRoutes = [
  { path: "/dashboard", component: Dashboard },
];

const surveyRoutes = [
  { path: "/surveys", component: Surveys },
  { path: "/surveys/completed", component: Surveys, props: { completed: true } },
  { path: "/survey/:surveyId/buildings", component: BuildingsSurveys },
  { path: "/survey/:surveyId/building/:buildingId/areas", component: Areas },
  { path: "/survey/:surveyId/building/:buildingId/area/:areaId/equipments", component: Equipments },
  { path: "/survey/:surveyId/building/:buildingId/area/:areaId/fireExtinguisher", component: FireExtinguisherEquipments },
  { path: "/survey/:surveyId/conduct", component: ConductSurvey },
  { path: "/survey/:surveyId/export", component: ExportSurvey },
];

const visitRoutes = [
  { path: "/visits", component: Visits },
  { path: "/visits/completed", component: Visits, props: { completed: true } },
  { path: "/visit/:visitId/buildings", component: BuildingsSurveys },
  { path: "/visit/:visitId/building/:buildingId/areas", component: Areas },
  { path: "/visit/:visitId/building/:buildingId/area/:areaId/equipments", component: Equipments },
  { path: "/visit/:visitId/building/:buildingId/area/:areaId/fireExtinguisher", component: FireExtinguisherEquipments },
];

const attendanceRoutes = [
  { path: "/attendance", component: Attendance },
];

// Helper function to create routes
const createRoutes = (routes, active) => {
  return routes.map(({ path, component: Component, props = {} }) => (
    <Route
      key={path}
      path={path}
      element={
        <RouteWrapper active={active}>
          <Component {...props} />
        </RouteWrapper>
      }
    />
  ));
};

const EmployeeRoutes = () => {
  return (
    <Routes>
      {createRoutes(dashboardRoutes, "dashboard")}
      {createRoutes(surveyRoutes, "surveys")}
      {createRoutes(visitRoutes, "visits")}
      {createRoutes(attendanceRoutes, "attendance")}
      <Route path="/:notfound" element={<NotFound />} />
    </Routes>
  );
};

export default EmployeeRoutes;
